module.exports = __webpack_public_path__ + "img/memuBj.dae5cf1d.jpg";